#import "../fragments/dashboard-stats-fragment.graphql"

query GetLandingPagesDashboard($input: DashboardInput!) {
    landingPagesDashboard(input: $input) {
        stat {
            ...DashboardStatsFragment
        }
        landingPages {
            page {
                id
                name
                htmlUrlPath
            }
            views
        }
        numLandingPages
    }
}
